import CloseIcon from '@mui/icons-material/Close';

interface IExpandedMediaViewProps {
  showExtendedMedia: boolean;
  handleClose: () => void;
  media: string;
  mediaAltText?: string;
}

const ExpandedOptionMedia = ({
  showExtendedMedia,
  handleClose,
  media,
  mediaAltText = '',
}: IExpandedMediaViewProps) => {
  if (!showExtendedMedia || !media) return null;

  return (
    <div
      className="bp-relative bp-mb-4 bp-cursor-pointer bp-overflow-hidden bp-rounded-lg bp-bg-white"
      onClick={handleClose}
    >
      <CloseIcon className="bp-hover:text-black bp-absolute bp-right-1 bp-top-1 bp-h-5 bp-w-5 bp-text-gray-500" />
      <div className="bp-relative">
        {media.split('.').pop() === 'mp4' ? (
          <video className="bp-mt-6 bp-h-full bp-w-full" controls autoPlay muted loop>
            <source src={media} type="video/mp4" />
          </video>
        ) : (
          <img className="bp-h-full bp-w-full" src={media} alt={mediaAltText} />
        )}
      </div>
    </div>
  );
};

export default ExpandedOptionMedia;
